import { Stack } from "@mui/material";
import {
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { HelpCircle } from "lucide-react";
import { observer } from "mobx-react";
import React from "react";
import { Trans } from "react-i18next";
import { useDeleteEmailTemplateStore } from "../../../stores/Hooks";

const CONFIRM_DELETE_DIALOG_DESCRIPTION_ICON = 20;

export const ConfirmEmailTemplateDeletionDialogContent: React.FC = observer(
  () => {
    const typography = useTypography();
    const tokens = useFoundationColorTokens();
    const spacing = useSpacing();
    const deleteEmailTemplateStore = useDeleteEmailTemplateStore();

    return (
      <Stack
        direction="row"
        {...typography.b2}
        color={tokens.labelError}
        gap={spacing.spaceXS}
      >
        <HelpCircle size={CONFIRM_DELETE_DIALOG_DESCRIPTION_ICON} />
        <div style={{ width: "fit-content" }}>
          <Trans
            i18nKey="emailTemplates.confirmDeleteDialogDescription"
            values={{
              templateName: deleteEmailTemplateStore.emailTemplateName.name,
            }}
            components={{
              span: <span style={{ ...typography.s2 }} />,
            }}
          />
        </div>
      </Stack>
    );
  },
);
